<template>
  <a-modal
    :title="name"
    :width="800"
    :footer="null"
    @cancel="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="24" :sm="12">
            <a-form-item
              label="员工姓名"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['name', {rules: [{required: true, message: '员工姓名不能为空！'}],initialValue: formData.name}]"/>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="联系方式"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['phone', {rules: [{required: true, message: '联系方式不能为空！'}],initialValue: formData.phone}]"/>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="性别"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-select :disabled="mode == 'view'"
                        v-decorator="['sex', {rules: [{required: true, message: '性别不能为空！'}],initialValue: formData.sex}]">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option :value="1">男</a-select-option>
                <a-select-option :value="2">女</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12" v-if="mode == 'add'">
            <a-form-item
              label="密码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-password type="password"
                                v-decorator="['password', {rules: [{required: true, message: '密码不能为空！'}],initialValue: formData.password}]"/>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12" v-if="mode == 'add'">
            <a-form-item
              label="确认密码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-password @blur.prevent="changeCount()" type="password"
                                v-decorator="['comfPassword', {rules: [{required: true, message: '确认密码不能为空！'}],initialValue: formData.comfPassword}]"/>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="所属门店"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['shopNo', {rules: [{required: true, message: '所属门店！'}], initialValue: formData.shopNo}]">
                <a-select-option v-for="item in shopData" :key="item.shopNo">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="授权售后服务"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select :disabled="mode == 'view'"
                        v-decorator="['authPostSale', {rules: [{required: true}],initialValue: formData.authPostSale}]">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option :value="1">是</a-select-option>
                <a-select-option :value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="授权后台权限"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select :disabled="mode == 'view'"
                        v-decorator="['authAdmin', {rules: [{required: true}],initialValue: formData.authAdmin}]">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option :value="1">是</a-select-option>
                <a-select-option :value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="授权配置权限"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select :disabled="mode == 'view'"
                        v-decorator="['authSetting', {rules: [{required: true}],initialValue: formData.authSetting}]">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option :value="1">是</a-select-option>
                <a-select-option :value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="授权查阅报表"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select :disabled="mode == 'view'"
                        v-decorator="['authReport', {rules: [{required: true}],initialValue: formData.authReport}]">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option :value="1">是</a-select-option>
                <a-select-option :value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-item
              label="备注"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-textarea :disabled="mode == 'view'" :rows="4"
                          v-decorator="['remark', {rules: [{required: false, message: '备注不能为空！'}], initialValue: formData.remark}]"/>
            </a-form-item>
          </a-col>
          <a-col align="center" v-if="mode != 'view'" :md="24" :sm="24">
            <a-button @click="handleSubmit" type="primary">提交</a-button>
            <a-button @click="handleCancel" style="margin-left: 10px">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import fieldRule from '@/utils/field-validate-rules'
  import {postAxios, getAxios} from '@/api/request'

  const formList = {
    name: '',
    phone: '',
    sex: '',
    password: '',
    authAdmin: '',
    authSetting: '',
    authReport: '',
    authPostSale: '',
    authGive: '',
    remark: '',
    id: '',
    shopNo: '',
    staffNo: '',
    authPostSale: ''
  }
  export default {
    name: 'shopAdd',
    data() {
      return {
        // 验证组件
//        fieldRule,
        name: '',
        mode: '',
        formData: {...formList},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        shopData: [
          {
            'shopNo': '',
            'name': '全部'
          }
        ],
        originalShopData: {
          'shopNo': '',
          'name': '全部'
        },
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this) // 注册后，才能通过表单拉取数据
      }
    },
    methods: {
      getShop() {
        const params = {}
        postAxios('shopList', params).then(res => {
          console.log(res)
          this.shopData = res
          this.shopData.splice(0, 0, this.originalShopData)
        })
      },
      add() {
        this.mode = 'add'
        this.name = '新增员工'
        this.visible = true
        this.getShop()
      },
      edit(record) {
        console.log(record)
        this.getShop()
        this.mode = 'edit'
        this.name = '编辑员工'
        this.visible = true
        if (record) {
          if (record.authGive) {
            record.authGive = 1
          } else {
            record.authGive = 0
          }

          if (record.authAdmin) {
            record.authAdmin = 1
          } else {
            record.authAdmin = 0
          }

          if (record.authSetting) {
            record.authSetting = 1
          } else {
            record.authSetting = 0
          }

          if (record.authReport) {
            record.authReport = 1
          } else {
            record.authReport = 0
          }
          if (record.authPostSale) {
            record.authPostSale = 1
          } else {
            record.authPostSale = 0
          }

          this.formData = record
        }
      },
      changeCount() {
        const comfPassword = this.form.getFieldValue('comfPassword')
        const password = this.form.getFieldValue('password')

        if (comfPassword != password) {
          alert('确认密码与密码不一致！！！')
        }
      },
      handleSubmit() {
        this.confirmLoading = true
        this.form.validateFields((err, values) => { // 表单验证
          if (!err) {
            if (this.formData.id) {
              values.id = this.formData.id
            }
            // 给密码加密
            values.password = this.$md5(this.formData.password).toUpperCase()
            console.log(values.password)
            if (this.mode === 'add') {
              console.log(values)
              delete values.comfPassword
              console.log(values)
              postAxios('addStaff', values).then(res => {
                this.confirmLoading = false
                this.handleCancel()
                this.$message.success('新增成功')
                this.$emit('ok', '') // 成功回调
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            } else if (this.mode === 'edit') {
              values.staffNo = this.formData.staffNo
              postAxios('updateStaff', values).then(res => {
                console.log(res)
                this.confirmLoading = false
                this.handleCancel()
                this.$message.success('修改成功')
                this.$emit('ok', '') // 成功回调
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            }
          } else {
            this.confirmLoading = false
          }
        })
      },
      handleCancel() {
        this.visible = false
        this.confirmLoading = false
        this.form.resetFields() // 清空表单
        this.formData = {...formList}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/staff/modules/staffAdd.vue